import { render, staticRenderFns } from "./DashboardDetails.vue?vue&type=template&id=a6950e92&"
import script from "./DashboardDetails.vue?vue&type=script&lang=js&"
export * from "./DashboardDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports